import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=3ee01ee2&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee01ee2",
  null
  
)

export default component.exports